<template>
  <picture class="blankable-picture">
    <source :media="media" :srcset="BLANK_IMAGE">
    <slot />
  </picture>
</template>

<script lang="ts" setup>
/**
 * Wraps the `<img>` in its slot so the browser does not fetch it over `media`: a
 * hidden `<img>` is still fetched, so the `<source>` offers an inline blank
 * candidate there instead. Outside `media` the `<img>` loads as it would alone.
 * The `<source>` has to come first: the browser takes the first one that matches.
 */
defineProps<{ media: string }>()

// A 1x1 transparent GIF. Inline, so selecting it costs no request.
const BLANK_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
</script>

<style lang="scss" scoped>
// Takes no box of its own, so the `<img>` lays out exactly as it does unwrapped.
.blankable-picture {
  display: contents;
}
</style>
